import { Image } from '@chakra-ui/image';
import {
    Box, Flex
} from '@chakra-ui/layout';
import { chakra } from '@chakra-ui/system';

export const ProfileImageWrapper = chakra(Box, {
    baseStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        h: '150px',
        minWidth: '150px',
        borderRadius: '75px',
        border: '1px solid var(--3p-colors-neutral-400)',
        backgroundColor: 'neutral.100',
        cursor: 'pointer',
        ['svg']: {
            h: '100px',
            w: '100px'
        }
    }
});

export const ProfileImage = chakra(Image, {
    baseStyle: {
        display: 'flex',
        h: '150px',
        minWidth: '150px',
        borderRadius: '75px',
        border: '1px solid var(--3p-colors-neutral-400)',
        backgroundColor: 'neutral.100',
        cursor: 'pointer'
    }
});

export const MenuPopper = chakra(Box, {
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        position: 'absolute',
        zIndex: '2',
        flexDirection: 'column',
        w: '155px',
        p: '3px 0',
        borderRadius: '5px',
        boxShadow: '1px 1px 3px var(--3p-colors-neutral-700)',
        bgColor: 'neutral.50'
    }
});

export const MenuPopperItem = chakra(Flex, {
    baseStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        h: '25px',
        w: '100%',
        p: '5px 10px',
        borderRadius: '5px',
        fontSize: '15px',
        cursor: 'pointer',
        _hover: { color: 'primary.600' }
    }
});
